import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { useBreakpointValue as n, useMultiStyleConfig as m, Flex as l } from "@chakra-ui/react";
import { GlobalFooterLogos as p } from "./GlobalFooterLogos.mjs";
const b = ({
  content1: e,
  content2: t,
  ...s
}) => {
  const o = n({ base: !0, md: !1 }, { fallback: "md" }), i = m("GlobalFooter");
  return /* @__PURE__ */ a(
    l,
    {
      sx: i.topContainer,
      p: o ? 4 : 10,
      flexDirection: o ? "column" : "row",
      rowGap: o ? 4 : 6,
      ...s,
      children: [
        /* @__PURE__ */ r(p, {}),
        e || /* @__PURE__ */ r(l, { flex: 1 }),
        t
      ]
    }
  );
};
export {
  b as GlobalFooterTopContainer
};
